import { showDeactivateTokenState } from '@/atoms';
import { useDeactivateToken } from '@/services/tokens';
import { Button, Group, Text } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { ModalLayout } from 'moh-ui';
import { useQueryClient } from 'react-query';
import { useRecoilState } from 'recoil-next';

export default function DeactivateTokenModal() {
   const [show, setShow] = useRecoilState(showDeactivateTokenState);
   const queryClient = useQueryClient();
   const { mutate: deactivateToken, isLoading } = useDeactivateToken();

   const handleClose = () => {
      setShow(null);
   };

   const handleDeactivate = () => {
      if (show?.token) {
         deactivateToken(show.token.id, {
            onSuccess: () => {
               queryClient.invalidateQueries('tokens');
               showNotification({
                  title: 'Success',
                  message: 'Token deactivated successfully',
                  color: 'green',
               });
               handleClose();
            },
            onError: (error) => {
               showNotification({
                  title: 'Error',
                  message: error.message || 'Failed to deactivate token',
                  color: 'red',
               });
            },
         });
      }
   };

   return (
      <ModalLayout open={Boolean(show?.show)} onClose={handleClose} size="md">
         <h2 className="text-xl font-semibold">Deactivate Token</h2>
         <Text mt="md">Are you sure you want to deactivate this token?</Text>
         <Group mt="xl">
            <Button variant="outline" onClick={handleClose} disabled={isLoading}>
               Cancel
            </Button>
            <Button color="red" onClick={handleDeactivate} loading={isLoading}>
               Deactivate
            </Button>
         </Group>
      </ModalLayout>
   );
}
